var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTouchShapesPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "139.43542mm",
    height: "199.49847mm",
    viewBox: "0 0 139.43542 199.49847",
    id: "svg424",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs421"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-37.252632,-26.098221)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.252632,
    y: 26.098221,
    width: 48.627506,
    height: 98.192696,
    rx: 24.313753,
    fill: "#f19fdf",
    id: "rect14",
    style: {
      strokeWidth: 0.264583
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchShapesPink);
export default __webpack_public_path__ + "static/media/touch_shapes_pink.932892bb7d9c5f7a66d32f215b6d6237.svg";
export { ForwardRef as ReactComponent };